// extracted by mini-css-extract-plugin
export default {"mainView":"event_mainView__K04Ci","title":"event_title__ptwz-"};